import cx from 'classnames';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

export interface PaperProps extends ComponentPropsWithoutRef<'div'> {
  isFixedTop?: boolean;
  isElevated?: boolean;
  children?: ReactNode;
}

export default function Paper({
  isElevated,
  isFixedTop,
  children,
  className,
  ...props
}: PaperProps) {
  return (
    <div
      {...props}
      className={cx(
        'wa-paper',
        {
          'wa-paper--elevated': isElevated,
          'wa-paper--fixed-top': isFixedTop,
        },
        className,
      )}
    >
      {children}
    </div>
  );
}
